import icons from '../../utils/icons';

const Error = () => {
    return <img src={icons.error} alt="" />;
};

export default Error;
